import * as _ from "lodash";
export var getLinkByName = function (from, name) {
    if (name === void 0) { name = "self"; }
    return _.find(from === null || from === void 0 ? void 0 : from.links, function (f) { return f.ref === name; });
};
export var getUriFromLinkByName = function (from, name) {
    var _a;
    if (name === void 0) { name = "self"; }
    return (_a = (_.find(from === null || from === void 0 ? void 0 : from.links, function (f) { return f.ref === name; }))) === null || _a === void 0 ? void 0 : _a.uri;
};
//# sourceMappingURL=LinkHelper.js.map